import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { C5VersionCheckerService } from '@app/shared/services/c5-version-checker.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BehaviorSubject, Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@UntilDestroy()
@Directive({
  selector: '[portalRequiredC5Version]',
  standalone: false,
})
export class RequiredC5VersionDirective {
  /**
   * Minimum c5 version number that matches the following format: /^\d+(?:\.\d+){0,3}$/
   *
   * Examples:
   *  - 7 matches everything above or equal to 7.0.0.0
   *  - 7.5 matches everything above or equal to 7.5.0.0
   *  - 7.5.6 matches everything above or equal to 7.5.6.0
   *  - 7.5.6.43 matches everything above or equal to 7.5.6.43
   */
  @Input('portalRequiredC5Version')
  requiredVersion!: string;

  @Input('portalRequiredC5VersionElse')
  elseTemplate?: TemplateRef<any>;

  @Input('portalRequiredC5VersionThen')
  thenTemplate?: TemplateRef<any>;

  private requiredVersion$: Subject<string>;

  constructor(
    private c5VersionCheckerService: C5VersionCheckerService,
    private template: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {}

  ngOnInit(): void {
    this.requiredVersion$ = new BehaviorSubject(this.requiredVersion);

    this.requiredVersion$
      .pipe(switchMap((requiredVersion) => this.c5VersionCheckerService.atLeast$(requiredVersion)))
      .pipe(untilDestroyed(this))
      .subscribe((requirementMet) => {
        // If not cleared it could happen that some elements are displayed multiple times
        this.viewContainer.clear();

        if (requirementMet) {
          if (this.thenTemplate != null) {
            this.viewContainer.createEmbeddedView(this.thenTemplate);
          } else {
            this.viewContainer.createEmbeddedView(this.template);
          }
        } else if (this.elseTemplate != null) {
          this.viewContainer.createEmbeddedView(this.elseTemplate);
        }
      });
  }
}
